import { render, staticRenderFns } from "./IsRehousingNeededQuestion.vue?vue&type=template&id=32e7a129&scoped=true"
import script from "./IsRehousingNeededQuestion.vue?vue&type=script&lang=ts"
export * from "./IsRehousingNeededQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e7a129",
  null
  
)

export default component.exports